import { FormLabel } from '@mui/material';
import { BaseFormLabelProps } from './BaseFormLabel.types';

/**
 * The MUI Form Label control used to separate MUI from our wrappers and
 * make it easier to mock away the MUI for unit testing.
 *
 * @param id - {@link BaseFormLabelProps.id id} description.
 * @param htmlFor - {@link BaseFormLabelProps.htmlFor htmlFor} description.
 * @param componentType - {@link BaseFormLabelProps.componentType componentType} description.
 * @param classes - {@link BaseFormLabelProps.classes classes} description.
 * @param children - {@link BaseFormLabelProps.children children} description.
 */
export const BaseFormLabel = ({
    id,
    htmlFor,
    componentType,
    classes,
    children,
}: BaseFormLabelProps) => {
    return (
        <FormLabel
            id={id}
            htmlFor={htmlFor}
            classes={{
                ...classes,
            }}
            component={componentType}
        >
            {children}
        </FormLabel>
    );
};